export const API_URL = process.env.REACT_APP_API_URL
export const BASIC_AUTH_LOGIN = process.env.REACT_APP_BASIC_AUTH_LOGIN
export const BASIC_AUTH_PASS = process.env.REACT_APP_BASIC_AUTH_PASS
export const OAUTH_DISCORD_URL = process.env.REACT_APP_DISCORD_OAUTH
export const ETH_NETWORK_CHAIN_ID = process.env.REACT_APP_ETH_NETWORK_CHAIN_ID
export const DISCORD_GUILD_INVITE = process.env.REACT_APP_DISCORD_GUILD_INVITE
